export const NO_GX_GO_ACCESS_REASON = 'NO_GX_GO_ACCESS';
export const API_ONLY_ACCESS_REASON = 'API_ONLY_ACCESS';
export const SUPPRESSION_LIST_REASON = 'SUPPRESSION_LIST';

const LEGACY_NO_GX_ACCESS_REASON = 'NO_GX_ACCESS';

const RESTRICTED_ACCESS_REASONS = new Set([API_ONLY_ACCESS_REASON]);

export const normalizeForbiddenReason = (forbiddenReason: string | null): string | null => {
  if (forbiddenReason === LEGACY_NO_GX_ACCESS_REASON) {
    return NO_GX_GO_ACCESS_REASON;
  }

  return forbiddenReason;
};

export const isRestrictedAccessReason = (forbiddenReason: string | null): boolean =>
  forbiddenReason != null && RESTRICTED_ACCESS_REASONS.has(forbiddenReason);
